import React, { createContext, useContext, useState, useMemo } from 'react';
import { calculateEnforcedStates } from '../utils/calculateEnforcedStates';
import { calculateAwakenStates } from '../utils/calculateAwakenStates';
import { calculateSynergyStates } from '../utils/calculateSynergyStates';
import { positionKeys } from '../utils/publicKeys';
import { setDeckEffects } from '../utils/setDeckEffects';
import calculateSetDeckStates from '../utils/calculateSetDeckStates';
import calculateSetDeckAdditionalStates from '../utils/calculateSetDeckAdditionalStates';

const baseSetDeckState = {
    isAvailable: false,
    selected: null, // left, right or null
    selection: null // team or year
}

const initialPlayerInfos = {
    'LF': null, 'CF': null, 'RF': null, '1B': null, '2B': null, '3B': null, 'SS': null,
    'C': null, 'DH': null, 'SUB1': null, 'SUB2': null, 'SUB3': null, 'SUB4': null, 'SUB5': null, 'SUB6': null,
    'SP1': null, 'SP2': null, 'SP3': null, 'SP4': null, 'SP5': null,
    'RP1': null, 'RP2': null, 'RP3': null, 'RP4': null, 'RP5': null, 'RP6': null, 'CP': null,
    'selectedTeam': null, 'selectedLineup': null,
    '1번': null, '2번': null, '3번': null, '4번': null, '5번': null, '6번': null, '7번': null, '8번': null, '9번': null,
    'setDeckStates': Array.from({ length: setDeckEffects.length }, () => ({ ...baseSetDeckState })),
    'defaultPlayerYear': null, 'defaultPitcherYear': null, 'defaultBatterYear': null,

};

const SquadContext = createContext(null);

function handleSynergy(playerInfos) {

    let newPlayerInfos = { ...playerInfos };

    for (let positionKey of positionKeys) {
        const player = newPlayerInfos[positionKey];
        if (player) {
            const synergyStates = calculateSynergyStates(player, newPlayerInfos, positionKey);
            newPlayerInfos = {
                ...newPlayerInfos,
                [positionKey]: {
                    ...player,
                    'synergyStates': synergyStates
                }
            };
        }
    }

    return newPlayerInfos;
}

function handleSetDeckAdditionalStates(playerInfos) {

    let newPlayerInfos = {...playerInfos};

    for (let positionKey of positionKeys) {
        const player = newPlayerInfos[positionKey];
        if (player) {
            const setDeckStates = calculateSetDeckAdditionalStates(player, newPlayerInfos, positionKey);
            // const setDeckStates = {s1: 0, s2: 0, s3: 0, s4: 0, s5: 0, s6: 0};
            newPlayerInfos = {
                ...newPlayerInfos,
                [positionKey]: {
                    ...player,
                    'setDeckStates': setDeckStates
                }
            };
        }
    }

    return newPlayerInfos;
}

export function SquadProvider({ children }) {
    const [playerInfos, setPlayerInfos] = useState(initialPlayerInfos);
    
    
    const addPlayer = (positionId, playerDetails) => {

        const enforcedStates = calculateEnforcedStates(playerDetails);
        const awakenStates = calculateAwakenStates(playerDetails);

        const newPlayer = {
            ...playerDetails,
                'enforcedStates': enforcedStates,
                'awakenStates': awakenStates,
        }

        let newPlayerInfos = {
            ...playerInfos,
            [positionId]: newPlayer
        }

        // 시너지 처리
        // for (let positionKey of positionKeys) {
        //     const player = newPlayerInfos[positionKey];
        //     if (player) {
        //         const synergyStates = calculateSynergyStates(player, newPlayerInfos);
        //         newPlayerInfos = {
        //             ...newPlayerInfos,
        //             [positionKey]: {
        //                 ...player,
        //                 'synergyStates': synergyStates
        //             }
        //         };
        //     }
        // }

        newPlayerInfos = handleSynergy(newPlayerInfos);
        newPlayerInfos = calculateSetDeckStates(newPlayerInfos);
        newPlayerInfos = handleSetDeckAdditionalStates(newPlayerInfos);

        setPlayerInfos(newPlayerInfos);
    };

    const setProperty = (key, value) => {
        
        let newPlayerInfos = {
            ...playerInfos,
            [key]: value
        }

        newPlayerInfos = handleSynergy(newPlayerInfos);
        newPlayerInfos = calculateSetDeckStates(newPlayerInfos);
        newPlayerInfos = handleSetDeckAdditionalStates(newPlayerInfos);


        setPlayerInfos(newPlayerInfos);
    }

    const setPlayers = (players) => {

        let newPlayerInfos = players

        newPlayerInfos = handleSynergy(newPlayerInfos);
        newPlayerInfos = calculateSetDeckStates(newPlayerInfos);
        newPlayerInfos = handleSetDeckAdditionalStates(newPlayerInfos);

        setPlayerInfos(newPlayerInfos);
    }
    
    const removePlayer = (positionId) => {

        let newPlayerInfos = {
            ...playerInfos,
            [positionId]: null
        }

        newPlayerInfos = handleSynergy(newPlayerInfos);
        newPlayerInfos = calculateSetDeckStates(newPlayerInfos);
        newPlayerInfos = handleSetDeckAdditionalStates(newPlayerInfos);  

        setPlayerInfos(newPlayerInfos);
    };

    const contextValue = useMemo(() => ({
        playerInfos,
        setProperty,
        addPlayer,
        setPlayers,
        removePlayer,
    }), [playerInfos]);

    return (
        <SquadContext.Provider value={contextValue}>
            {children}
        </SquadContext.Provider>
    );
}

export function useSquad() {
    const context = useContext(SquadContext);
    if (!context) {
        throw new Error('useSquad must be used within a SquadProvider');
    }
    return context;
}